import { useQuery } from "react-query";
import axios from "axios";
import { useState } from "react";
import { rootUrl, pms_endpoint } from "../../../utils/useAxios";
import { decryptPayload } from "../../../utils/useAxios";

export const useBankData = () => {
	const [bankFormat, setBankFormat] = useState([]);
	const fetchBankList = async () => {
		const { data } = await axios.get(`${rootUrl}${pms_endpoint}/banks/`);

		const res = JSON.parse(decryptPayload(data.data));

		if (res) {
			const modifiedResponse = res?.data?.map((state) => {
				return {
					value: state,
					label: state.name,
				};
			});
			setBankFormat(modifiedResponse);
		}

		return data;
	};
	return [bankFormat, useQuery("banklist", fetchBankList)];
};
